export enum IntegrationType {
  Email = 0,
  Calendar = 1,
  Editor = 2,
  PublicPortal = 3,
  InvoiceSystem = 4,
  KSeF = 5,
  GovEDelivery = 6,
  Epuap = 7,

  ContactForm = 9,
  Upe = 10,
}
